<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <van-field v-model="inputForm.code" label="审批单编号" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.companyName" label="宣传内容所属公司" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.departName" label="宣传内容所属部门" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.contentTitle" label="宣传内容标题" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.postDate" label="发布日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.promotionContentTypeName" label="宣传内容类别" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.promotionFormTypeName" label="宣传形式类别" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.promotionPlatformTypeName" label="宣传平台类别" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.promotionContent" label="宣传内容" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.promotionFee" label="预估宣传费用（元）" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.attachList.length > 0">
        <p style="color: #AAA">附件</p>
        <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
      </div>
      <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      <van-field v-model="inputForm.createDate" label="制单日期" label-width="130px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "@/components/processRecord/processRecord.vue";
import TaskService from "@/api/flowable/TaskService";
import ProcessService from "@/api/flowable/ProcessService";
export default {
  name: "CulturePromotionContentPostInfo",
  data(){
    return {
      activeNames: [],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      inputForm:{
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'culture_promotion_content_post_info'
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/culture/promotion/content/post/info/queryById').then(({ data }) => {
        this.inputForm = data
        if (!data.attachIds) {
          this.inputForm.attachList = []
        }
        if (data.createDate) {
          this.inputForm.createDate = data.createDate.slice(0, 10)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          _this.$flow.startFlow(form, '/culture/promotion/content/post/info/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable
          }
          _this.$flow.startFlow(form, '/culture/promotion/content/post/info/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
  }
}
</script>

<style scoped>

</style>
